import { Link, Typography } from '@mui/material'
import { useClientDetails } from 'stores/utils/hooks/useClientDetails'

export const TUEV_CERTIFICATE_HEADLINE = '100% Datenschutz'

export const TuevCertificateLogo = () => {
  const clientDetails = useClientDetails()

  return (
    <img
      alt={`${clientDetails?.company} tuev`}
      src={clientDetails?.logos?.tuev}
      style={{
        width: '80px',
        minWidth: 'unset',
        maxWidth: '160px',
        display: 'flex'
      }}
      data-testid="tuev-image"
    />
  )
}

export const TuevCertificateContent = () => (
  <>
    {/* @TOdox bold */}
    <Typography variant="body2" fontWeight="bold">
      Die Sicherheit Ihrer Daten hat höchste Priorität
    </Typography>
    <br />
    <Typography variant="body2">Das TÜV-Siegel wird erteilt von:</Typography>
    <br />

    <Typography variant="body2">
      Wir unterziehen uns regelmäßig einer freiwilligen Datenschutzprüfung durch
      den TÜV Saarland.
    </Typography>
    <br />

    <Typography variant="body2">
      TÜV Saarland i. A. Tobias Kohl, LL.M. Rechtsanwalt Consultant Datenschutz
      und Compliance{' '}
      <Link
        href="https://www.tekit.de"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        www.tekit.de
      </Link>
      <br />
      tekit Consult Bonn GmbH TÜV Saarland Gruppe Alexanderstraße 10, 53111 Bonn
    </Typography>
    <br />
    <Typography variant="body2">
      <Link
        href="https://www.finanzcheck.de/tuev-geprueftes-portal/"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        Zum FINANZCHECK TÜV-Zertifikat
      </Link>
    </Typography>
  </>
)
